// Load Bootstrap init
import {initBootstrap} from "./bootstrap.js";

// Loading bootstrap with optional features
initBootstrap({
  tooltip: false,
  popover: true,
  toasts: false,
});

const sm = window.matchMedia('(min-width: 0px) and (max-width: 767px)' );
const md = window.matchMedia( '(min-width: 768px) and (max-width: 991px)' );
const lg = window.matchMedia( '(min-width: 992px) and (max-width: 1279px)' );
const xl = window.matchMedia( '(min-width: 1280px)' );
const body = document.querySelector( 'body' );
let isScrolling;
let lastScrollTop = 0;

// window.addEventListener( 'scroll', () => {
//   if ( xl.matches ) {
//     // Get the current vertical scroll position
//     let currentScrollTop = window.scrollY || document.documentElement.scrollTop;

//     // Compare current position with the last known position
//     if (currentScrollTop > lastScrollTop) {
//       clearTimeout( isScrolling ); // Clear any previous timeout

//       isScrolling = setTimeout(() => {
//         // This function will execute after a brief pause in scrolling
//         body.classList.remove( 'contract-navigation' );

//       }, 132); // Adjust the delay as needed (e.g., 66ms for 15fps)

//       body.classList.add( 'contract-navigation' );

//     } else if (currentScrollTop < lastScrollTop) {
//         // Scrolling up
//         body.classList.remove( 'contract-navigation' );
//     }

//     // Update the last scroll position for the next comparison
//     lastScrollTop = currentScrollTop;
//   }
// });